import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Workspace = {
  id: string;
  name: string;
  default_currency: string;
  role: 'owner' | 'member';
};

type WorkspaceState = {
  current: Workspace | null;
  setCurrent: (ws: Workspace | null) => void;
  clear: () => void;
};

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      current: null,
      setCurrent: (ws) => set({ current: ws }),
      clear: () => set({ current: null }),
    }),
    { name: 'spent-tracker-workspace' },
  ),
);
